
import { Component, Vue } from 'vue-property-decorator'
import CollectionDetail from './collectionDetail.vue'

@Component({
    components: {
        CollectionDetail
    }
})
export default class extends Vue {
    private type: string = 'recommend'
    private recommendId: number = 0
}
